import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  OutlinedBtnPrimary,
  SectionTitle,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import useAssAreaPlacaPrevistaCarregamento from './AssocAreaPlacaPrevistaCarregamentoState'
import NumberFormat from 'react-number-format'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'

export default connect()(withRouter(AssocAreaPlacaPrevistaCarregamento))

function AssocAreaPlacaPrevistaCarregamento({ history, dispatch }) {
  const { picking_id } = history.location.state

  // Hook
  const { state, localDispatcher } = useAssAreaPlacaPrevistaCarregamento()
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    localDispatcher.fetchPlacas(picking_id)
  }, [])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
    }
  }, [state.successMessage])

  useEffect(() => {
    if (state.btnLoading) {
      dispatch(showLoadingBox('Realizando a associação das áreas'))
    } else {
      dispatch(hideLoadingBox())
    }
  }, [state.btnLoading])

  useEffect(() => {
    if (state.navigateBack) {
      history.goBack()
    }
  }, [state.navigateBack])

  // Render
  return (
    <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
      <div className="p-grid">
        <div className="p-col-12">
          <SectionTitle title="Placas Previstas Para Carregamento - Ordem de Carregamento" />
        </div>
        <div className="p-col-5">
          <OutlinedBtnPrimary
            label={'Associar Áreas A Partir da Ordem de Carregamento'}
            onClick={() =>
              localDispatcher.associarAreas(
                state.placas,
                picking_id,
                state.addBadgeToAreaNickname,
                state.addInfoComplementarToAreaNickname,
              )
            }
          />
        </div>
        <div className="p-col-3">
          <CustomCheckbox
            onChange={() => localDispatcher.toggleAddBadgeToAreaNickname()}
            checked={state.addBadgeToAreaNickname}
          >
            Associar Placa ao Apelido da Área
          </CustomCheckbox>
        </div>
        <div className="p-col-3">
          <CustomCheckbox
            onChange={() => localDispatcher.toggleAddInfoComplementarToAreaNickname()}
            checked={state.addInfoComplementarToAreaNickname}
          >
            Associar Info. Complementar da Área
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <DataTable
            header={<CustomDataTableHeader onChange={setGlobalFilter} />}
            globalFilter={globalFilter}
            value={state.placas}
            emptyMessage="Não existe Placas associadas as entregas"
            rows={20}
            paginator
            loading={state.loading}
          >
            <Column field="placa_info" header="Placa" />
            <Column field="cidades" header="Cidades" />
            <Column
              field="qte_identificadores"
              header="Qte Identif."
              style={tableCellCentered(150)}
            />
            <Column field="peso" header="Peso KG" style={tableCellCentered(120)} />
            <Column
              header="Ordem"
              style={tableCellCentered()}
              body={item => (
                <NumberFormat
                  decimalScale={0}
                  allowNegative={false}
                  style={{ width: 60 }}
                  value={item.ordem}
                  onChange={value => localDispatcher.onOrdemChange(item, value.target.value)}
                />
              )}
            />
          </DataTable>
        </div>
      </div>
    </CustomPanel>
  )
}
